import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, getFormValues, FormSection, SubmissionError, change, reset } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import classNames from 'classnames';
import ReactLoading from 'react-loading';
import Modal from 'react-responsive-modal';
//import RichTextEditor from 'react-rte';
import ReactQuill from 'react-quill';
import ArtistLoginForm from '../../components/ArtistLoginForm';
import ReactDragListView from 'react-drag-listview/lib/index.js';
//import { DragDropContent, Droppable, Draggable } from "react-beautiful-dnd";
import Nestable from 'react-nestable';

import agent from '../../agent'

// import validate from './registration/validate';
import renderDatePicker from '../Datepicker';
import Countries from '../../data/countries';
import CountryStates from '../../data/states';

import _range from 'lodash/range'
import _debounce from 'lodash/debounce'

import { history } from '../../store/configureStore'
import SelectComponent from '../ui/SelectComponent'

import AMLogo from '../../assets/images/audition-magic-favicon.png';
import CloseButton from '../../assets/images/close-dark.png';

// import ReactJson from 'react-json-view'
import RadioGroupComponent from '../ui/RadioGroupComponent'

const renderField = ({ input, className, label, type, meta: { asyncValidating, touched, error, warning } }) => {
  if (touched && error) {
    return (
      <div className={className}>
      <div className="input-field">
        <label className="is-invalid-label">
          <input 
            {...input} 
            type={type}
            className="is-invalid-input" 
            placeholder={label} />
          <span className="form-error is-visible" id="uuid">{error}</span>
          { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
        </label>
      </div>
      </div>
    )
  }
  return (
    <div className={className}>
    <div className="input-field">
      <label>
        <input {...input} placeholder={label} type={type} />
        { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
      </label>
    </div>
    </div>
  )
}

class ResumeForm extends Component {
  rowCredits = [{ id: 0, col1: "", col2: "", col3: "", col4: "", col5: "", ordinal: 1}, 
                { id: 1, col1: "", col2: "", col3: "", col4: "", col5: "", ordinal: 2}, 
                { id: 2, col1: "", col2: "", col3: "", col4: "", col5: "", ordinal: 3}]

  resume = [{ type: 'text', title: "", content: "", ordinal: 1},
            { type: 'table', title: "", rowCredits: this.rowCredits, selected_col: 4, ordinal: 2}]

  state = {
    resume: this.resume,
    modalDelete: false,
    message: '',
    tempOrdinal: 0,
    tempOrdinal2: 0,
    type: ''
  }

  tableFix2 = {
    marginBottom: '0'
  }
  tableFix = {
    border: '1px solid #fff',
    backgroundColor: '#fff'
  }
  creditsIcon = {
    fontSize: '2rem',
    color: '#000',
    paddingRight: '0'
  }

  componentWillMount() {
    const { resume } = this.props
    console.log('componentWillMount-resume', resume, this.props)
    if (resume) {
      try {
        var arrResume = JSON.parse(resume)
        var text = {}
        var table = {}
        var arrRes = []
        var rowCredits = []
        arrResume.map((item, i) => {
          if (!Array.isArray(item[1])) {
            text = { type: 'text', title: item[0], content: item[1], ordinal: i+1 }
            console.log('before-pushing-text', text)
            arrRes.push(text)
          } else {
            item.map((inner, k) => {
              if (Array.isArray(inner)) {
                var credits = { id: k-1 }
                inner.map((inner2, g) => {
                  if (g === 0) { credits = { ...credits, col1: inner2, ordinal: k } }
                  if (g === 1) { credits = { ...credits, col2: inner2, ordinal: k } }
                  if (g === 2) { credits = { ...credits, col3: inner2, ordinal: k } }
                  if (g === 3) { credits = { ...credits, col4: inner2, ordinal: k } }
                  if (g === 4) { credits = { ...credits, col5: inner2, ordinal: k } }
                })
                rowCredits.push(credits)
              }
            })
            table = { type: 'table', title: item[0], rowCredits: rowCredits, selected_col: item[i].length, ordinal: i+1 }
            console.log('before-pushing-table', table)
            arrRes.push(table)
          }
        })
        this.setState({
          resume: arrRes
        })
      } catch (e) {
        return
      }
    }
    console.log('componentWillMount-resume', arrRes, this.props)
  }

  componentWillReceiveProps (nextProps) {
    
  }

  componentDidUpdate(prevProps) {
    console.log('componentDidUpdate', this.state.resume)
    window.localStorage.setItem('global_artist_resume', JSON.stringify(this.state.resume));
  }

  submit = (values, dispatch, props) => {
    //agent.Artist.updateProfile()
  }

  addSection = (type, ordinal) => {
    if (type === 'text') {
      this.setState((prevState) => ({
        resume: [...prevState.resume, { type: "text", title: "", content: "", ordinal: ordinal }]
      }));
    } else {
      this.setState((prevState) => ({
        resume: [...prevState.resume, { type: "table", title: "", rowCredits: this.rowCredits, selected_col: 4, ordinal: ordinal }]
      }));
    }
  }

  removeSection = ordinal => e => {
    var test = this.state.resume.find(k => k.ordinal === ordinal)
    if (test.type === 'text') {
      if (test.title !== '' ||
          test.content !== '') {
        this.setState({ modalDelete: true, tempOrdinal: ordinal, type: test.type,
          message: 'Are you sure you want to delete this section and all data included?' })
        return;
      }
    } else if (test.type === 'table') {
      const res = test.rowCredits.map((val, idx) => {
        return (val.col1 !== '' || val.col2 !== '' || val.col3 !== '' ||
               val.col4 !== '' || val.col5 !== '')
      })
      if (test.title !== '' || res.some(function(a) { return a; })) {
        this.setState({ modalDelete: true, tempOrdinal: ordinal, type: test.type,
          message: 'Are you sure you want to delete this section and all data included?' })
        return;
      }
    }
    //delete if no value on each field
    var resume = this.state.resume
    resume = resume.filter(k => k.ordinal !== ordinal)
    const newData = resume.map((val, idx) => {
                      return { ...val, ordinal: idx + 1 }
                    })
    this.setState({
      resume: newData,
      modalDelete: false,
      tempOrdinal: 0
    })
  }

  removeCredits = (outOrdinal, inOrdinal) => e => {
    var test = this.state.resume.find(k => k.ordinal === outOrdinal)
    var test2 = test.rowCredits.find(k => k.ordinal === inOrdinal)
    if (test2.col1 !== '' || test2.col2 !== '' || test2.col3 !== '' || test2.col4 !== '' || test2.col5 !== '') {
      this.setState({ modalDelete: true, tempOrdinal: outOrdinal, tempOrdinal2: inOrdinal, type: 'rowcredits',
        message: 'Are you sure you want to delete this credit?' })
      return;
    }
    //delete if no value on each field
    var match = this.state.resume.find(k => k.ordinal === outOrdinal)
    var rowCredits = match.rowCredits.filter(k => k.ordinal !== inOrdinal)
    rowCredits = rowCredits.map((val, idx) => {
                      return { ...val, ordinal: idx + 1 }
                    })
    var newData = this.state.resume.map((val, idx) => {
      return val.ordinal === outOrdinal ? { ...val, rowCredits: rowCredits } : { ...val }
    })
    this.setState({
      resume: newData
    })
  }

  // addTableCat = (value, ordinal) => {
  //   this.setState((prevState) => ({
  //     resume: { table: [...prevState.resume.table, { title: "", content: "", ordinal: ordinal } ],
  //               text: [...prevState.resume.text] }
  //   }));
  // }

  addCredits = (value, outOrdinal, inOrdinal) => {
    var match = this.state.resume.find(k => k.ordinal === outOrdinal)
    var filtered = this.state.resume.filter(k => k.ordinal !== outOrdinal)
    var rowCredits = match.rowCredits
    rowCredits = [...rowCredits, { id: inOrdinal - 1, col1: "", col2: "", col3: "", col4: "", col5: "", ordinal: inOrdinal }]
    filtered = [...filtered, { type: match.type, title: match.title, rowCredits: rowCredits, 
      selected_col: match.selected_col, ordinal: match.ordinal }]
    filtered = filtered.sort(function(a,b) { return a.ordinal - b.ordinal })
    this.setState({
      resume: filtered
    })
  }

  onChangeCell = (outOrdinal, inOrdinal, colIndex) => e => {
    const resume = this.state.resume
    const value = e.target.value
    var match = resume.find(k => k.ordinal === outOrdinal)
    var filtered = resume.filter(k => k.ordinal !== outOrdinal)
    var rowCredit = match.rowCredits.find(k => k.ordinal === inOrdinal)
    var rowCredits = match.rowCredits.filter(k => k.ordinal !== inOrdinal)
    switch (colIndex) {
      case 1 :
        rowCredits = [...rowCredits, { id:rowCredit.ordinal - 1, col1: value, col2: rowCredit.col2, col3: rowCredit.col3, 
          col4: rowCredit.col4, col5: rowCredit.col5, ordinal: rowCredit.ordinal }]
        break;
      case 2:
        rowCredits = [...rowCredits, { id:rowCredit.ordinal - 1, col1: rowCredit.col1, col2: value, col3: rowCredit.col3, 
          col4: rowCredit.col4, col5: rowCredit.col5, ordinal: rowCredit.ordinal }]
        break;
      case 3:
        rowCredits = [...rowCredits, { id:rowCredit.ordinal - 1, col1: rowCredit.col1, col2: rowCredit.col2, col3: value, 
            col4: rowCredit.col4, col5: rowCredit.col5, ordinal: rowCredit.ordinal }]
        break;
      case 4:
        rowCredits = [...rowCredits, { id:rowCredit.ordinal - 1, col1: rowCredit.col1, col2: rowCredit.col2, col3: rowCredit.col3, 
            col4: value, col5: rowCredit.col5, ordinal: rowCredit.ordinal }]
        break;
      case 5:
        rowCredits = [...rowCredits, { id:rowCredit.ordinal - 1, col1: rowCredit.col1, col2: rowCredit.col2, col3: rowCredit.col3, 
            col4: rowCredit.col4, col5: value, ordinal: rowCredit.ordinal }]
        break;
    }
    rowCredits = rowCredits.sort(function(a,b) { return a.ordinal - b.ordinal })
    filtered = [...filtered, { type: match.type, title: match.title, rowCredits: rowCredits, selected_col: match.selected_col, ordinal: match.ordinal }]
    this.setState({
      resume: filtered
    })
    // console.log('resume', resume)
    // console.log('value', value)
    // console.log('match', match)
    // console.log('rowCredit', rowCredit)
    // console.log('rowCredits', rowCredits)
    // console.log('ordinals', outOrdinal, inOrdinal)
    // console.log('----------------------------------')
  }

  // addTextCat = (value, ordinal) => {
  //   this.setState((prevState) => ({
  //     resume: { table: [...prevState.resume.table], 
  //               text: [...prevState.resume.text, { title: "", rowCredits: this.rowCredits, selected_col: 4, ordinal: ordinal }] }
  //   }));
  //   console.log('addTextCat', this.state.resume)
  // }

  onChangeTitle = ordinal => e => {
    const resume = this.state.resume
    const value = e.target.value
    var match = resume.find(k => k.ordinal === ordinal)
    var filtered = resume.filter(k => k.ordinal !== ordinal)
    filtered = match.type === 'text' ?
      [...filtered, { type: match.type, title: value, content: match.content, ordinal: match.ordinal} ] :
      [...filtered, { type: match.type, title: value, rowCredits: match.rowCredits, selected_col: match.selected_col, ordinal: match.ordinal} ]
    filtered = filtered.sort(function(a,b) { return a.ordinal - b.ordinal })
    this.setState({
      resume: filtered
    })
  }

  // handleChangeTableTitle = ordinal => e => {
  //   const newTable = this.state.resume.table.map((val, idx) => {
  //     if (val.ordinal == ordinal) {
  //       console.log('handleChangeTableTitle-true', e.target.value, ordinal)
  //       const match = this.state.resume.table.find(k => k.ordinal == ordinal)
  //       const text = this.state.resume.text
  //       var filtered = this.state.resume.table.filter(k => k.ordinal != ordinal)
  //       filtered.push({ title: e.target.value, content: match.content, ordinal: ordinal })
  //       this.setState({ resume: { table: filtered, text: text } })
  //       return
  //     }
  //   })
  // }

  // handleChangeTextTitle = ordinal => e => {
  //   const newTable = this.state.resume.text.map((val, idx) => {
  //     if (val.ordinal == ordinal) {
  //       console.log('handleChangeTextTitle-true', e.target.value, ordinal)
  //       const match = this.state.resume.text.find(k => k.ordinal == ordinal)
  //       const table = this.state.resume.table
  //       var filtered = this.state.resume.text.filter(k => k.ordinal != ordinal)
  //       filtered.push({ title: e.target.value, rowCredits: match.rowCredits, selected_col: match.selected_col, ordinal: ordinal })
  //       this.setState({ resume: { table: table, text: filtered } })
  //       return
  //     }
  //   })
  // }

  // onChangeRTE = (value, ordinal) => {
  //   const match = this.state.resume.table.find(k => k.ordinal == ordinal)
  //   const text = this.state.resume.text
  //   var filtered = this.state.resume.table.filter(k => k.ordinal != ordinal)
  //   filtered.push({ title: match.title, content: value, ordinal: ordinal })
  //   this.setState({ resume: { table: filtered, text: text } })
  // }

  // onChange = (value) => {
  //   this.setState({value});
  //   if (this.props.onChange) {
  //     // Send the changes up to the parent component as an HTML string.
  //     // This is here to demonstrate using `.toString()` but in a real app it
  //     // would be better to avoid generating a string on each change.
  //     this.props.onChange(
  //       value.toString('html')
  //     );
  //   }
  // };

  onChangeContent = ordinal => e => {
    const resume = this.state.resume
    const value = e
    var match = resume.find(k => k.ordinal === ordinal)
    var filtered = resume.filter(k => k.ordinal !== ordinal)
    filtered = [...filtered, { type: match.type, title: match.title, content: value, ordinal: match.ordinal} ]
    filtered = filtered.sort(function(a,b) { return a.ordinal - b.ordinal })
    this.setState({
      resume: filtered
    })
  }

  click_column = (col, ordinal) => {
    // var filtered = this.state.selected_column.filter(k => k.row != row)
    // console.log('filtered', filtered)
    // filtered.push({row: row, col: col})
    // this.setState({
    //   selected_column: filtered
    // })
    var match = this.state.resume.find(k => k.ordinal === ordinal)
    var filtered = this.state.resume.filter(k => k.ordinal !== ordinal)
    filtered.push({ type: match.type, title: match.title, rowCredits: match.rowCredits, selected_col: col, ordinal: ordinal})
    filtered = filtered.sort(function(a,b) { return a.ordinal - b.ordinal })
    this.setState({
      resume: filtered
    })
  }

  onCloseModal = () => {
      this.setState({ modalDelete: false });
  }

  onYesDelete = () => {
    if (this.state.type === 'text' || this.state.type === 'table') {
      var resume = this.state.resume
      resume = resume.filter(k => k.ordinal !== this.state.tempOrdinal)
      const newData = resume.map((val, idx) => {
                        return { ...val, ordinal: idx + 1 }
                      })
      this.setState({
        resume: newData,
        modalDelete: false,
        tempOrdinal: 0,
        tempOrdinal2: 0,
        type: ''
      })
    } else if (this.state.type === 'rowcredits') {
      var match = this.state.resume.find(k => k.ordinal === this.state.tempOrdinal)
      var rowCredits = match.rowCredits.filter(k => k.ordinal !== this.state.tempOrdinal2)
      rowCredits = rowCredits.map((val, idx) => {
                        return { ...val, ordinal: idx + 1 }
                      })
      var newData = this.state.resume.map((val, idx) => {
        return val.ordinal === this.state.tempOrdinal ? { ...val, rowCredits: rowCredits } : { ...val }
      })
      this.setState({
        resume: newData,
        modalDelete: false,
        tempOrdinal: 0,
        tempOrdinal2: 0,
        type: ''
      })
    }
  }

  //might not be used
  onDragEndCredits = (flag, outOrdinal) => (fromIndex, toIndex) => {
    if (flag === 'outer') {
      const data = this.state.resume;
      const item = data.splice(fromIndex, 1)[0];
      data.splice(toIndex, 0, item);
      // +1 base on index
      const newData = data.map((val, idx) => {
                        return { ...val, ordinal: idx + 1 }
                      })
      this.setState({
        resume: newData
      });
    } else if (flag === 'inner') {
      const resume = this.state.resume.find(k => k.ordinal === outOrdinal)
      const data = resume.rowCredits;
      const item = data.splice(fromIndex, 1)[0];
      data.splice(toIndex, 0, item);
      const newData = data.map((val, idx) => {
        return { ...val, ordinal: idx + 1, id: idx }
      })
      var resumes = this.state.resume.filter(k => k.ordinal !== outOrdinal)
      resumes = [...resumes, { type: resume.type, title: resume.title, rowCredits: newData, selected_col: resume.selected_col, ordinal: resume.ordinal }]
      this.setState({
        resume: resumes
      })
    }
  }

  renderItem = (value, idx) => item => {
    let row1Id = `artist.resume[rowCredits[row${idx}-${item.item.id}]]`, row2Id = `row${idx}-${item.item.id}`, row3Id = `row${idx}-${item.item.id}`, row4Id = `row${idx}-${item.item.id}`, row5Id = `row${idx}-${item.item.id}`
    let cellSizes = value.selected_col === 1 ? ['10'] :
                    value.selected_col === 2 ? ['5','5'] :
                    value.selected_col === 3 ? ['4','3','3'] :
                    value.selected_col === 4 ? ['3','3','2','2'] :
                    value.selected_col === 5 ? ['2','2','2','2','2'] : []
    let fixBottom = {
      paddingBottom: '1rem'
    }
    return (
      <div>
      {
        window.innerWidth > 400 ?
          (<table style={this.tableFix2}>
            <tbody style={this.tableFix}>
              <tr>
                <td className="table-padding">
                  { value.selected_col >= 1 && (<input className="cell-margin" type="text" name={row1Id} data-id={item.item.id} id={row1Id} value={item.item.col1} onChange={this.onChangeCell(value.ordinal, item.item.ordinal, 1)} />) }</td>
                <td className={classNames('table-padding', {'hide' : !cellSizes[1]})}>
                  { value.selected_col >= 2 && (<input className="cell-margin" type="text" name={row2Id} data-id={item.item.id} id={row2Id} value={item.item.col2} onChange={this.onChangeCell(value.ordinal, item.item.ordinal, 2)} />) }</td>
                <td className={classNames('table-padding', {'hide' : !cellSizes[2]})}>
                  { value.selected_col >= 3 && (<input className="cell-margin" type="text" name={row3Id} data-id={item.item.id} id={row3Id} value={item.item.col3} onChange={this.onChangeCell(value.ordinal, item.item.ordinal, 3)} />) }</td>
                <td className={classNames('table-padding', {'hide' : !cellSizes[3]})}>
                  { value.selected_col >= 4 && (<input className="cell-margin" type="text" name={row4Id} data-id={item.item.id} id={row4Id} value={item.item.col4} onChange={this.onChangeCell(value.ordinal, item.item.ordinal, 4)} />) }</td>
                <td className={classNames('table-padding', {'hide' : !cellSizes[4]})}>
                  { value.selected_col >= 5 && (<input className="cell-margin" type="text" name={row5Id} data-id={item.item.id} id={row5Id} value={item.item.col5} onChange={this.onChangeCell(value.ordinal, item.item.ordinal, 5)} />) }</td>
                <td className="table-padding" width="100">
                  <div className="row align-right">
                    <a style={this.creditsIcon} className="column medium-5 fa fa-times" aria-hidden="true"
                      onClick={this.removeCredits(value.ordinal, item.item.ordinal)}></a>&nbsp;&nbsp;
                    <a href="#" style={this.creditsIcon} className="column medium-5 end drag-handle fa fa-arrows" aria-hidden="true"></a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>) : 
          (<div style={fixBottom}>
            <div style={fixBottom} className="grid-x align-right">
              <a style={this.creditsIcon} className="cell medium-5 small-5 fa fa-times" aria-hidden="true"
                onClick={this.removeCredits(value.ordinal, item.item.ordinal)}></a>&nbsp;&nbsp;
              <a href="#" style={this.creditsIcon} className="cell medium-5 small-5 end drag-handle fa fa-arrows" aria-hidden="true"></a>
            </div>
            { value.selected_col >= 1 && (<input className="cell-margin" type="text" name={row1Id} data-id={item.item.id} id={row1Id} value={item.item.col1} onChange={this.onChangeCell(value.ordinal, item.item.ordinal, 1)} />) }
            { value.selected_col >= 2 && (<input className="cell-margin" type="text" name={row2Id} data-id={item.item.id} id={row2Id} value={item.item.col2} onChange={this.onChangeCell(value.ordinal, item.item.ordinal, 2)} />) }
            { value.selected_col >= 3 && (<input className="cell-margin" type="text" name={row3Id} data-id={item.item.id} id={row3Id} value={item.item.col3} onChange={this.onChangeCell(value.ordinal, item.item.ordinal, 3)} />) }
            { value.selected_col >= 4 && (<input className="cell-margin" type="text" name={row4Id} data-id={item.item.id} id={row4Id} value={item.item.col4} onChange={this.onChangeCell(value.ordinal, item.item.ordinal, 4)} />) }
            { value.selected_col >= 5 && (<input className="cell-margin" type="text" name={row5Id} data-id={item.item.id} id={row5Id} value={item.item.col5} onChange={this.onChangeCell(value.ordinal, item.item.ordinal, 5)} />) }
          </div>)
      }
      </div>
    )
  }

  modules = {
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{'list': 'ordered'}, {'list': 'bullet'}]
      ],
    }

    formats = [
      'bold', 'italic', 'underline',
      'list', 'bullet'
    ]

  render() {
    const { handleSubmit, submitting, pristine, artistType, initialValues, disableButton } = this.props
    let { cats, rowSections, catSection, selected_column, resume } = this.state
    
    const pFix = {
      color: '#fff',
      textAlign: 'center'
    }
    const divFix = {
      padding: '0 1rem'
    }
    const filmFix = {
      fontSize: '2rem',
      color: '#000',
      paddingLeft: '0',
      paddingRight: '0'
    }
    // const closeFix = {
    //   fontSize: '2rem',
    //   color: '#000',
    //   marginLeft: '42px'
    // }
    const dragFix = {
      paddingRight: '0.5rem'
    }
    const topRowFix = {
      paddingBottom: '2rem'
    }
    const bottomRowFix = {
      paddingTop: '2rem'
    }
    // const heightAdjust = {
    //   height: '2rem',
    //   marginBottom: '0'
    // }
    const squared = {
      width: '2rem',
      textAlign: 'center',
      lineHeight: 'initial'
    }
    const paddingBottom = {
      paddingBottom: '1.25rem'
    }
    const marginBottom = {
      marginBottom: '0'
    }
    const marginRight = {
      marginRight: '0.5rem'
    }
    const that = this;
    const dragProps = {
      onDragEnd (fromIndex, toIndex) {
        const data  = that.state.resume;
        const item = data.splice(fromIndex, 1)[0];
        data.splice(toIndex, 0, item);
        // +1 base on index
        const newData = data.map((val, idx) => {
                          return { ...val, ordinal: idx + 1 }
                        })
        that.setState({
          resume: newData
        });
      },
      nodeSelector: 'li',
      handleSelector: 'a'
    };

    const items = [
        { id: 0, text: 'Andy' },
        {
          id: 1, text: 'Harry',
          children: [{ id: 2, text: 'David' }]
        },
        { id: 3, text: 'Lisa' }
    ];
    // const dragProps2 = {
    //   onDragEnd(fromIndex, toIndex) {
    //     const data  = that.state.resume.text;
    //     const item = data.splice(fromIndex, 1)[0];
    //     data.splice(toIndex, 0, item);
    //     console.log('dragProps2', data, item)
    //     that.setState({
    //       resume: { table: that.state.resume.table, text: data }
    //     });
    //   },
    //   nodeSelector: 'li',
    //   handleSelector: 'span'
    // };
    return (
      <div>
        <Modal classNames={{ modal: 'small-modal' }} open={this.state.modalDelete} onClose={this.onCloseModal} little>
          <h2 className="reveal-title">Confirm Delete</h2> 
          <p>{this.state.message}</p>
          <div className="clearfix"></div>
          <button className="button float-right" onClick={this.onCloseModal}>CANCEL</button>
          <button style={marginRight} className="button float-right" onClick={this.onYesDelete}>YES, DELETE</button>
        </Modal>
        <form onSubmit={handleSubmit} className="registartion-profile-form registration-fix-form" id="reg-profile-form">
            <section className="section gray-bg">
              <div style={divFix} className="grid-x align-center">
                <p style={pFix}>Please create your custom resume below including your relevant categories, columns and sections</p>
              </div>
              <div className="grid-x align-center">
                <a className="button primary" onClick={e => this.addSection("text", resume.length + 1)}>ADD A NEW TEXT SECTION</a>
                <a className="button primary" onClick={e => this.addSection("table", resume.length + 1)}>ADD A NEW CATEGORY/TABLE</a>
              </div>
            </section>
            <section id="resume-section" className="section gray-bg">
              <div className="grid-x align-center">
              <div className="small-12 medium-9 large-8 cell">
                <FormSection name="artist">
                  <ReactDragListView id="drag1" onDragEnd={this.onDragEndCredits('outer', 0)} nodeSelector="li" handleSelector='a'>
                    <ol className="ol-fix">
                    {
                      resume.map((val, idx) => {
                        if (val.type === 'text') {
                          let titleId = `resume[title-text-${val.ordinal}]`, contentId = `resume[content-text-${val.ordinal}]`
                          return (
                            <li key={idx} className="row" name="resume">
                              <div className="column small-4 medium-1 align-right">
                                <a href="#" className="resume-section-close" aria-hidden="true"
                                  onClick={this.removeSection(val.ordinal)}>
                                  <img src={CloseButton} width="50px" />
                                </a>
                              </div>
                              <div className="column category-text padding-wrapper">
                                <div style={paddingBottom} className="grid-x align-middle">
                                  <div className="cell medium-6 small-10">
                                    <input name={titleId} type="text" label="TITLE" value={val.title}
                                      onChange={this.onChangeTitle(val.ordinal)} />
                                  </div>
                                  <div className="cell medium-6 small-2">
                                    <div className="row medium-3 align-right">
                                      <a href="#" style={filmFix} className="fa fa-arrows column medium-3 align-right" aria-hidden="true"></a>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="column medium-12">
                                    <ReactQuill name={contentId} placeholder="Tell a story" 
                                      className="editing-area" theme="snow" value={val.content} 
                                      onChange={this.onChangeContent(val.ordinal)} 
                                      modules={this.modules} formats={this.formats}>
                                    </ReactQuill>
                                  </div>
                                </div>
                              </div>
                            </li>)
                        } else if (val.type === 'table') {
                          let titleId = `resume[title-table-${val.ordinal}]`
                          return (
                            <li key={idx} className="row" name="resume">
                              <div className="column medium-1 small-4 align-right">
                                <a href="#" className="resume-section-close" aria-hidden="true"
                                  onClick={this.removeSection(val.ordinal)}>
                                  <img src={CloseButton} width="50px" />
                                </a>
                              </div>
                              <div className="column text-sec padding-wrapper">
                                <div style={topRowFix} className="grid-x align-middle">
                                  <div className="cell medium-6 resume-credits-title">
                                    <input name={titleId} type="text" label="TITLE" value={val.title}
                                      onChange={this.onChangeTitle(val.ordinal)} />
                                  </div>
                                  <div className="cell medium-5 small button-group align-right resume-credits-table">
                                    <a style={squared} name={`button1-${idx}`} data-id={idx} id={`button1-${idx}`} className={classNames('column-button', { 'column-button-selected' : val.selected_col == 1 })} 
                                      onClick={e => this.click_column(1, val.ordinal)}>1</a>
                                    <a style={squared} name={`button2-${idx}`} data-id={idx} id={`button2-${idx}`} className={classNames('column-button', { 'column-button-selected' : val.selected_col == 2 })}
                                      onClick={e => this.click_column(2, val.ordinal)}>2</a>
                                    <a style={squared} name={`button3-${idx}`} data-id={idx} id={`button3-${idx}`} className={classNames('column-button', { 'column-button-selected' : val.selected_col == 3 })}
                                      onClick={e => this.click_column(3, val.ordinal)}>3</a>
                                    <a style={squared} name={`button4-${idx}`} data-id={idx} id={`button4-${idx}`} className={classNames('column-button', { 'column-button-selected' : val.selected_col == 4 })}
                                      onClick={e => this.click_column(4, val.ordinal)}>4</a>
                                    <a style={squared} name={`button5-${idx}`} data-id={idx} id={`button5-${idx}`} className={classNames('column-button', { 'column-button-selected' : val.selected_col == 5 })}
                                      onClick={e => this.click_column(5, val.ordinal)}>5</a>
                                  </div>
                                  <div style={dragFix} className="cell medium-1">
                                    <div className="row align-right">
                                      <a href="#" style={filmFix} className="fa fa-arrows column medium-6" aria-hidden="true"></a>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <Nestable
                                    items={val.rowCredits}
                                    renderItem={this.renderItem(val, idx)} />
                                </div>
                                <div style={bottomRowFix} className="row">
                                  <div className="column add-credit-padding"><a className="button primary" onClick={e => this.addCredits(e.target.value, val.ordinal, val.rowCredits.length + 1)}>ADD A NEW CREDIT</a></div>
                                </div>
                              </div>
                            </li>)
                        }
                      })
                    }
                    </ol>
                  </ReactDragListView>
                  
                </FormSection>
              </div>
              </div>
            </section>    
            <section className="section">
              <div className="grid-x align-center">
                <div className="small-12 cell text-center">
                  <button className="button primary" 
                    type="submit">
                      {submitting || disableButton ? 'Saving...' : 'Save' }
                  </button>
                </div>
              </div>
            </section>
        </form>
      </div>
    )
  }
}

ResumeForm = reduxForm({
  form: 'artistProfile', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate,
  // asyncValidate,
  // asyncBlurFields: ['first_name', 'last_name', 'email']
})(ResumeForm)

const mapStateToProps = state => ({
  
});

const mapDispatchToProps = dispatch => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(ResumeForm);


// WEBPACK FOOTER //
// ./src/components/profile/ResumeForm.js